import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoTypo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 260,
	height: 40,
	viewBox: "0 0 260 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M33.724 36.5809C37.7426 32.5622 40.0003 27.1118 40.0003 21.4286C40.0003 15.7454 37.7426 10.2949 33.724 6.27629C29.7054 2.25765 24.2549 1.02188e-06 18.5717 0C12.8885 -1.02188e-06 7.43807 2.25764 3.41943 6.27628L10.4905 13.3473C11.6063 14.4631 13.4081 14.4074 14.8276 13.7181C15.9836 13.1568 17.2622 12.8571 18.5717 12.8571C20.845 12.8571 23.0252 13.7602 24.6326 15.3677C26.2401 16.9751 27.1431 19.1553 27.1431 21.4286C27.1431 22.7381 26.8435 24.0167 26.2822 25.1727C25.5929 26.5922 25.5372 28.394 26.6529 29.5098L33.724 36.5809Z",
			fill: "#297AFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 40H19.5098C17.9943 40 16.5408 39.398 15.4692 38.3263L1.67368 24.5308C0.60204 23.4592 0 22.0057 0 20.4902V10L30 40Z",
			fill: "#34C2FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7143 39.9999H4.28571C1.91878 39.9999 0 38.0812 0 35.7142V29.2856L10.7143 39.9999Z",
			fill: "#34C2FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.137 6.9292C252.577 6.9292 259.448 13.8007 259.448 22.2407V33.0708H251.979V22.2407C251.979 19.1411 250.112 16.4522 247.498 15.1825V33.0708H240.029V22.2407C240.029 19.1411 238.161 16.4522 235.547 15.1825V33.0708H228.078V6.9292H232.186C235.024 6.9292 237.713 7.75079 240.029 9.13256V6.9292H244.137Z",
			fill: "#0F2D5E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225.112 22.2407C225.112 28.2159 220.219 33.0708 214.281 33.0708C208.306 33.0708 203.451 28.2159 203.451 22.2407V6.9292H210.92V22.2407C210.92 24.108 212.414 25.6018 214.281 25.6018C216.111 25.6018 217.643 24.108 217.643 22.2407V6.9292H225.112V22.2407Z",
			fill: "#0F2D5E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.174 24.6682C201.174 29.2616 197.439 32.9961 192.846 32.9961H181.754V25.5271H192.846C193.294 25.5271 193.705 25.1536 193.705 24.6682C193.705 24.22 193.294 23.8466 192.846 23.8466H189.821C185.153 23.8466 181.381 20.0747 181.381 15.4066C181.381 10.7384 185.153 6.9292 189.821 6.9292H200.8V14.3982H189.821C189.261 14.3982 188.85 14.8464 188.85 15.4066C188.85 15.9294 189.261 16.3775 189.821 16.3775H192.846C197.439 16.3775 201.174 20.112 201.174 24.6682Z",
			fill: "#0F2D5E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M170.441 6.9292C175.67 6.9292 179.964 11.2239 179.964 16.4522C179.964 21.7179 175.67 25.9752 170.441 25.9752H167.64V33.0708H160.171V6.9292H170.441ZM170.441 18.5062C171.562 18.5062 172.495 17.6099 172.495 16.4522C172.495 15.3319 171.562 14.3982 170.441 14.3982H167.64V18.5062H170.441Z",
			fill: "#0F2D5E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.809 33.0708H149.34V6.9292H156.809V33.0708Z",
			fill: "#0F2D5E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.046 20C147.046 27.2076 141.145 33.0708 133.975 33.0708C126.767 33.0708 120.904 27.2076 120.904 20C120.904 12.8297 126.767 6.9292 133.975 6.9292C141.145 6.9292 147.046 12.8297 147.046 20ZM139.577 20C139.577 16.9377 137.037 14.3982 133.975 14.3982C130.875 14.3982 128.373 16.9377 128.373 20C128.373 23.0997 130.875 25.6018 133.975 25.6018C137.037 25.6018 139.577 23.0997 139.577 20Z",
			fill: "#0F2D5E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.731 18.3195V33.0708H109.394C102.187 33.0708 96.3235 27.2076 96.3235 20C96.3235 12.8297 102.187 6.9292 109.394 6.9292H118.731V14.3982H109.394C106.295 14.3982 103.793 16.9377 103.793 20C103.793 23.0997 106.295 25.6018 109.394 25.6018H111.262V18.3195H118.731Z",
			fill: "#0F2D5E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.1128 20C95.1128 27.2076 89.2122 33.0708 82.042 33.0708C74.8343 33.0708 68.9712 27.2076 68.9712 20C68.9712 12.8297 74.8343 6.9292 82.042 6.9292C89.2122 6.9292 95.1128 12.8297 95.1128 20ZM87.6437 20C87.6437 16.9377 85.1043 14.3982 82.042 14.3982C78.9423 14.3982 76.4402 16.9377 76.4402 20C76.4402 23.0997 78.9423 25.6018 82.042 25.6018C85.1043 25.6018 87.6437 23.0997 87.6437 20Z",
			fill: "#0F2D5E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.2015 25.6018V33.0708H58.8652C55.1307 33.0708 52.1431 30.0832 52.1431 26.3487V6.9292H59.6121V25.6018H68.2015Z",
			fill: "#0F2D5E"
		})
	]
});
export default SvgLogoTypo;
